'use client'

import { cn } from '@/lib/utils'
import { stripHtmlToPlainText } from '@/lib/notebook/text/plain-text-value'

function escapeHtml(text) {
  return String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

function toDisplayHtml(value, richText) {
  const raw = value ?? ''
  if (!richText) {
    const plain = stripHtmlToPlainText(raw)
    return `<p>${escapeHtml(plain)}</p>`
  }
  if (!raw.trim()) return '<p></p>'
  if (raw.trim().startsWith('<')) return raw
  return `<p>${escapeHtml(raw)}</p>`
}

/**
 * Read-only mirror of NotebookTiptapField surface — same classes/DOM shape, no ProseMirror.
 */
export function NotebookStaticField({
  value = '',
  richText = false,
  singleLine = false,
  inline = false,
  className = '',
  style,
  locked = false,
  placeholder = '',
  onActivate,
}) {
  const html = toDisplayHtml(value, richText)
  const isInline = Boolean(inline)
  const isEmpty = !stripHtmlToPlainText(value).trim()

  if (isInline && !richText) {
    const text = stripHtmlToPlainText(value) || (placeholder ? '' : '\u00a0')
    return (
      <span
        className={cn('nb-tiptap-field nb-tiptap-field--static', className)}
        style={style}
        data-nb-tiptap-static
        data-nb-inline=""
        data-single-line={singleLine || undefined}
        data-empty={isEmpty || undefined}
        data-placeholder={placeholder || undefined}
        tabIndex={locked ? -1 : 0}
        onMouseDown={(event) => {
          if (locked) return
          event.preventDefault()
          onActivate?.()
        }}
      >
        {text || (
          <span className="nb-tiptap-placeholder" aria-hidden>
            {placeholder}
          </span>
        )}
      </span>
    )
  }

  return (
    <div
      className={cn('nb-tiptap-field nb-tiptap-field--static', className)}
      style={{
        width: isInline || singleLine ? 'auto' : '100%',
        minWidth: isInline ? '3ch' : singleLine ? '6ch' : '12ch',
        flex: singleLine && !isInline ? '1 1 auto' : undefined,
        maxWidth: '100%',
        ...style,
      }}
      data-nb-tiptap-static
      data-nb-inline={isInline ? '' : undefined}
      data-single-line={singleLine || undefined}
      data-empty={isEmpty || undefined}
      data-placeholder={placeholder || undefined}
      tabIndex={locked ? -1 : 0}
      onMouseDown={(event) => {
        if (locked) return
        event.preventDefault()
        onActivate?.()
      }}
      onFocus={(event) => {
        if (locked) return
        event.preventDefault()
        onActivate?.()
      }}
    >
      {isEmpty && placeholder ? (
        <p className="nb-tiptap-placeholder" aria-hidden>
          {placeholder}
        </p>
      ) : (
        <div
          className="nb-tiptap-static-surface"
          data-placeholder={placeholder || undefined}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </div>
  )
}
